import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Button, Snackbar } from '../mui/Core/index'
import { resetSnackbar } from './generic-snackbar-slice'
import Constants from '../../constants/en.json'

export function GenericSnackbar({ handleSnackbarClose }) {
  const dispatch = useDispatch()
  const open = useSelector((state) => state.snackbar.open)
  const message = useSelector((state) => state.snackbar.message)
  const severity = useSelector((state) => state.snackbar.severity)
  const autoHideDuration = useSelector((state) => state.snackbar.autoHideDuration)
  const isAction = useSelector((state) => state.snackbar.action)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      dispatch(resetSnackbar())
    }
    dispatch(resetSnackbar())
    if (handleSnackbarClose) {
      handleSnackbarClose()
    }
  }

  const dismissAction = (
    <Button
      data-testid='snackbar-dismiss-action'
      color='inherit'
      size='medium'
      onClick={handleClose}
    >
      {Constants.snackbar.DISMISS}
    </Button>
  )

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert
        severity={severity}
        variant='filled'
        sx={{ width: '100%' }}
        action={isAction ? dismissAction : ''}
        onClose={handleClose}
        icon={false}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

GenericSnackbar.propTypes = {
  handleSnackbarClose: PropTypes.func,
}

export default GenericSnackbar
